import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMutation } from '@apollo/client';
import { CREATE_PURCHASE } from '../gql/createPurchase';
import { APOLLO_COMMERCE_CONTEXT } from '@chegg/commerce-utils';

// @todo: Update any with appropriate types

/**
 * Returns the response from Create Purchase mutation
 */
var useCreatePurchase = function useCreatePurchase() {
  var _useMutation = useMutation(CREATE_PURCHASE, {
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    }),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createPurchase = _useMutation2[0],
    _useMutation2$ = _useMutation2[1],
    createPurchaseData = _useMutation2$.data,
    createPurchaseError = _useMutation2$.error;
  return {
    createPurchase: createPurchase,
    createPurchaseData: createPurchaseData,
    createPurchaseError: createPurchaseError
  };
};
export default useCreatePurchase;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/hooks/useCreatePurchase.js
// module id = 4675
// module chunks = 11